import React from 'react';
import MainLayout from '../../components/mainLayOut/MainLayout';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  const testimonials = [
    {
      name: "Rahul Sharma",
      age: 10,
      achievement: "National Abacus Champion 2023",
      quote: "Ascent Abacus helped me improve my calculation speed by 300%!",
      image: "https://xsgames.co/randomusers/assets/avatars/male/1.jpg" // Changed to reliable placeholder
    },
    {
      name: "Priya Patel",
      age: 9,
      achievement: "State Level Gold Medalist",
      quote: "I love my abacus classes! The teachers make learning so much fun.",
      image: "https://xsgames.co/randomusers/assets/avatars/female/2.jpg" // Changed to reliable placeholder
    },
    {
      name: "Arjun Gupta",
      age: 11,
      achievement: "International Competition Finalist",
      quote: "My math grades improved from C to A+ after joining Ascent Abacus!",
      image: "https://xsgames.co/randomusers/assets/avatars/male/3.jpg" // Changed to reliable placeholder
    }
  ];

  return (
    <MainLayout>
      {/* Hero Section - Full width */}
      <div className="w-full bg-gradient-to-r from-blue-600 to-purple-600 py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Unlock Your Child's Mental Math Potential</h1>
            <p className="text-xl mb-8">Join 2000+ students who have transformed their math skills with our proven abacus methodology</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link 
                to="/programs" 
                className="bg-white text-blue-600 hover:bg-blue-50 font-bold py-3 px-6 rounded-full transition-all shadow-lg hover:shadow-xl"
              >
                Explore Programs
              </Link>
              <a 
                href="https://www.youtube.com/@ASCENTABACUSANDBRAINGYM" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-transparent border-2 border-white hover:bg-white/20 font-bold py-3 px-6 rounded-full transition-all shadow-lg hover:shadow-xl flex items-center"
              >
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                </svg>
                Watch Videos
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Our Story Section */}
      <div className="w-full py-16">
        <div className=" px-4 ">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Story</h2>
              <p className="text-lg text-gray-700 mb-6">
                Founded in 2010 by Mrs. Anjali Mehta, a renowned mental math expert, Ascent Abacus has grown from a single classroom to a national network of learning centers.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                Our unique "Brain Gym" methodology combines traditional abacus techniques with modern cognitive development exercises to create a holistic learning experience.
              </p>
              <div className="flex items-center space-x-4">
                <img 
                  src="https://randomuser.me/api/portraits/women/65.jpg" 
                  alt="Founder" 
                  className="w-16 h-16 rounded-full border-4 border-white shadow-md"
                />
                <div>
                  <p className="font-medium">Mrs. Anjali Mehta</p>
                  <p className="text-blue-600">Founder & Chief Instructor</p>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1588072432836-e10032774350?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
                alt="Children learning abacus" 
                className="rounded-2xl shadow-xl w-full"
              />
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-2xl shadow-lg">
                <div className="text-4xl font-bold text-blue-600">12+</div>
                <div className="text-gray-700">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Student Testimonials */}
      <div className="w-full bg-gray-50 py-16">
        <div className=" px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Shining Stars</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((student, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-4">
                  <img 
                    src={student.image} 
                    alt={student.name} 
                    className="w-16 h-16 rounded-full border-4 border-blue-100 mr-4"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `https://via.placeholder.com/150/0000FF/FFFFFF?text=${student.name.charAt(0)}`;
                    }}
                  />
                  <div>
                    <h3 className="font-bold text-lg">{student.name}, {student.age}</h3>
                    <p className="text-blue-600 text-sm">{student.achievement}</p>
                  </div>
                </div>
                <p className="text-gray-700 italic">"{student.quote}"</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Video Section */}
      <div className="w-full py-16">
        <div className=" px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">See Us In Action</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="aspect-w-16 aspect-h-9">
              <iframe 
                className="w-full h-96 rounded-2xl shadow-lg"
                src="https://www.youtube.com/embed/FWDC40h0Kqc?si=pgzVgSRP-75koiet" 
                title="Ascent Abacus Demo"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
            <div className="aspect-w-16 aspect-h-9">
              <iframe 
                className="w-full h-96 rounded-2xl shadow-lg"
                src="https://www.youtube.com/embed/Xeg7lxtSUcc?si=yJaBubQ8CY-KFRx-" 
                title="Student Success Stories"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Social Proof */}
      <div className=" bg-white py-16">
        <div className="px-4 ">
          <div className=" bg-white rounded-2xl shadow-lg p-8 text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Join Our Growing Community</h2>
            <div className="flex justify-center space-x-10 mb-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600">2K+</div>
                <div className="text-gray-700">Students</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600">50+</div>
                <div className="text-gray-700">Awards Won</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600">15+</div>
                <div className="text-gray-700">Cities</div>
              </div>
            </div>
            <div className="flex justify-center space-x-4">
              <a href="https://www.facebook.com/ascentabacusbraingym" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white p-3 rounded-full hover:bg-blue-700 transition-all">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/ascent_abacus_brain_gym/" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-3 rounded-full hover:from-purple-700 hover:to-pink-700 transition-all">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a href="https://www.youtube.com/@ASCENTABACUSANDBRAINGYM" target="_blank" rel="noopener noreferrer" className="bg-red-600 text-white p-3 rounded-full hover:bg-red-700 transition-all">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AboutUs;